import { connect } from 'react-redux';
import _ from 'lodash';

import StepFilterDetails from '../../components/compound/execution/StepFilterDetails';
import { getFieldPathKeys, getFieldPathsFor } from '../../reducers/analyticsApp';

// проходит по всем возможным path чтобы найти нужный лейбл, если лейбл не найден вернет path
const getFieldLabel = (path, state) =>
  _.get(
    getFieldPathKeys(state)
      .flatMap((pathKey) => getFieldPathsFor(state, pathKey))
      .find((s) => s.path === path),
    'label',
    path
  );

const mapStateToProps = (state) => ({
  getFieldLabel: (field) => getFieldLabel(field, state),
});

export default connect(mapStateToProps)(StepFilterDetails);
